import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/lib/AuthContext";
import LanguageSwitcher from "@/components/LanguageSwitcher";

export default function MarketingNav() {
  const { user } = useAuth();
  const { t } = useTranslation();
  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-slate-950/60 border-b border-white/10" data-testid="marketing-navbar">
      <div className="max-w-7xl mx-auto px-4 lg:px-10">
        <div className="h-16 flex items-center justify-between gap-2">
          <Link to="/" className="flex items-center gap-2 group min-w-0 shrink" data-testid="logo-home">
            <span className="block w-2 h-2 rounded-full pulse-dot shrink-0" style={{ background: "linear-gradient(135deg,#7C3AED,#2563EB)" }}></span>
            <span className="font-display font-bold text-base sm:text-xl tracking-tight text-white truncate">
              Open<span className="brand-text-light">Payments</span>
            </span>
          </Link>
          <nav className="hidden md:flex items-center gap-8 text-sm">
            <Link to="/empresas" className="link-underline text-white/75 hover:text-white" data-testid="nav-business">{t("nav.business")}</Link>
            <Link to="/arquitectura-defi" className="link-underline text-white/75 hover:text-white">{t("nav.defi")}</Link>
            <Link to="/terminos" className="link-underline text-white/75 hover:text-white">{t("nav.terms")}</Link>
          </nav>
          <div className="flex items-center gap-2 sm:gap-3 shrink-0">
            {/* Language switcher inline on >= sm; on mobile it drops to the row below */}
            <span className="hidden sm:block"><LanguageSwitcher tone="light" /></span>
            {user ? (
              <Link to="/app" className="btn-primary text-sm" data-testid="nav-go-to-app">→</Link>
            ) : (
              <>
                <Link to="/login" className="text-sm font-semibold text-white/85 hover:text-white whitespace-nowrap" data-testid="nav-login">
                  {t("nav.login")}
                </Link>
                <Link to="/registro" className="btn-primary text-sm whitespace-nowrap" data-testid="nav-register">
                  {t("nav.register")}
                </Link>
              </>
            )}
          </div>
        </div>
        {/* Mobile-only second row: language switcher below the login/register actions */}
        <div className="sm:hidden flex justify-end pb-2 -mt-1">
          <LanguageSwitcher tone="light" />
        </div>
      </div>
    </header>
  );
}
